export class Contactos{
    constructor(
        public  idContacto: number,
        public  nombre: string,
        public  mail: string,
        public  mensaje: string,
        public privacidad: number
    ){}
}